import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

function Services() {
  return (
    <div className="services-page">

      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/services.png')" }}
      >
        <div className="hero-text-container">
          <h1>Our Services</h1>
          <p>Smart financial, compliance, and business services to drive your growth.</p>
        </div>
      </section>

      {/* Services List */}
      <div className="services-container">
        {/* 1. Virtual CFO */}
        <Link to="/services/virtual-cfo" className="service-link">
          <div className="service-section">
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + '/images/service1.jpg'} alt="Virtual CFO" />
            </div>
            <div className="service-content">
              <h2>Virtual CFO Services</h2>
              <p>Strategic financial leadership for startups and growing businesses without the cost of a full-time CFO.</p>
              <ul>
                <li>Strategic Financial Advisory</li>
                <li>Financial Forecasting</li>
                <li>MIS & KPI Dashboards</li>
                <li>Cash Flow Management</li>
                <li>Budgeting & Variance Analysis</li>
                <li>Fundraising Support</li>
              </ul>
            </div>
          </div>
        </Link>

        {/* 2. Bookkeeping & Accounting */}
        <Link to="/services/bookkeeping" className="service-link">
          <div className="service-section reverse">
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + '/images/service2.jpg'} alt="Accounting" />
            </div>
            <div className="service-content">
              <h2>Bookkeeping & Accounting</h2>
              <p>Accurate financial recording, reporting, and compliance.</p>
              <ul>
                <li>Ledger Maintenance</li>
                <li>AR/AP Management</li>
                <li>Bank Reconciliation</li>
                <li>Inventory & Assets</li>
                <li>Audit Support</li>
              </ul>
            </div>
          </div>
        </Link>

        {/* 3. Taxation */}
        <Link to="/services/taxation" className="service-link">
          <div className="service-section">
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + '/images/service3.jpg'} alt="Taxation" />
            </div>
            <div className="service-content">
              <h2>Taxation Services</h2>
              <p>Comprehensive tax compliance and planning: income tax, TDS, and GST.</p>
              <ul>
                <li>IT Filing & Planning</li>
                <li>GST Filing</li>
                <li>Tax Audits & Representation</li>
                <li>International Taxation</li>
                <li>Transfer Pricing & DTAA</li>
              </ul>
            </div>
          </div>
        </Link>

        {/* 4. Corporate Law */}
        <Link to="/services/corporate-law" className="service-link">
          <div className="service-section reverse">
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + '/images/service4.jpg'} alt="Corporate Law" />
            </div>
            <div className="service-content">
              <h2>Corporate Law & Secretarial</h2>
              <p>Incorporation, ROC compliance, governance, and legal filings.</p>
              <ul>
                <li>Business Setup (Pvt Ltd, LLP)</li>
                <li>ROC Filings</li>
                <li>Shareholder & Director Support</li>
                <li>Corporate Governance Advisory</li>
                <li>Event-driven Compliance</li>
              </ul>
            </div>
          </div>
        </Link>

        {/* 5. Startup Consulting */}
        <Link to="/services/startup-consulting" className="service-link">
          <div className="service-section">
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + '/images/service5.jpg'} alt="Startup Consulting" />
            </div>
            <div className="service-content">
              <h2>Startup Consulting</h2>
              <p>From incorporation to scaling and fundraising, FINTEXL is your startup’s strategic partner.</p>
              <ul>
                <li>Legal Setup & Equity Structuring</li>
                <li>Business Plan & Pitch Decks</li>
                <li>Financial Modeling</li>
                <li>KPI Dashboards</li>
                <li>ESOPs & Cap Table Management</li>
              </ul>
            </div>
          </div>
        </Link>

        {/* 6. Business Advisory */}
        <Link to="/services/business-advisory" className="service-link">
          <div className="service-section reverse">
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + '/images/service6.jpg'} alt="Business Advisory" />
            </div>
            <div className="service-content">
              <h2>Business Advisory</h2>
              <p>High-level restructuring, cost optimization, M&A, and risk control.</p>
              <ul>
                <li>Restructuring & Turnaround</li>
                <li>Cost Optimization</li>
                <li>M&A Support</li>
                <li>Feasibility & Valuation</li>
                <li>Risk Management & Controls</li>
              </ul>
            </div>
          </div>
        </Link>

        {/* 7. International Business */}
        <Link to="/services/international-business" className="service-link">
          <div className="service-section">
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + '/images/service7.jpg'} alt="International Business" />
            </div>
            <div className="service-content">
              <h2>International Business</h2>
              <p>Cross-border strategy, FEMA/RBI filings, and currency compliance.</p>
              <ul>
                <li>FDI/ODI Setup</li>
                <li>FEMA Compliance</li>
                <li>Trade Documentation</li>
                <li>Transfer Pricing</li>
                <li>Forex Risk Hedging</li>
              </ul>
            </div>
          </div>
        </Link>

        {/* 8. Payroll & HR */}
        <Link to="/services/payroll-hr" className="service-link">
          <div className="service-section reverse">
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + '/images/service8.jpg'} alt="Payroll & HR" />
            </div>
            <div className="service-content">
              <h2>Payroll & HR Services</h2>
              <p>Payroll, HR compliance, onboarding, helpdesk, and admin.</p>
              <ul>
                <li>Salary Processing</li>
                <li>PF/ESI/TDS Compliance</li>
                <li>Leave & Bonus Handling</li>
                <li>HR Documentation</li>
                <li>Recruitment Coordination</li>
              </ul>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Services;
